import { __assign, __rest } from "tslib";
import React from 'react';
import Position from './Position';
/** @type {any} */
var PinTL = React.forwardRef(function (_a, ref) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(Position, __assign({ left: 0, position: "absolute", ref: ref, top: 0 }, props), children));
});
export default PinTL;
